import AlertPopup from '../ui/AlertPopup';
import Disaster from './Disaster';
import common from '../common';

export default class Earthquake extends Disaster {
	constructor(world) {
		super(world);

		this._canUpdate = true;
		this.pulses = 12;
		this.pulseFrequency = 0.24;
		this._destroyed = false;
		this.pulseForce = { min: 1, max: 4 };

		this._sourceTile = this._world.getTile(P3.math.randomInt(0, this._world.columns - 1),
			P3.math.randomInt(0, this._world.rows - 1));

		for (let y = 0, rows = this._world.rows; y < rows; ++y) {
			for (let x = 0, columns = this._world.columns; x < columns; ++x) {
				const tile = this._world.getTile(x, y);

				this.initTile(tile);
			}
		}
		this._ambientSound = P3.audio.playSound('sfx_eq_ambience_loop_00', { loop: true });
	}

	destroy() {
		this._destroyed = true;
		this._canUpdate = false;
		super.destroy();
	}

	initTile(tile) {
		const distance = Math.max(this._world.columns, this._world.rows);
		const to = new P3.Vector2(this._sourceTile.tx - tile.tx, this._sourceTile.ty - tile.ty);
		const magnitude = Math.max(0.1, 1 - (to.lengthSq / (distance * distance)));

		tile.quakeAmplitude *= magnitude * 0.5;

		tile.quake = {
			magnitude,
			health: tile.strength,
			isFire: false,
		};
	}

	start() {
		if (super.start()) {
			P3.audio.playSound('sfx_eq_disaster_strikes_00', {
				callback: () => {
					this.end();
				},
			});
			this._world.startQuake(() => {
				const frequency = this.pulseFrequency;

				function next() {
					this.pulse();

					if (--this.pulses > 0) {
						P3.utils.delayg(this._tweens, frequency, () => {
							next.call(this);
						});
					}
					// this.pulses === 0 && this.end();
				}
				next.call(this);
			});
		}
	}

	end() {
		this._world.stopQuake(() => {
			const tiles = this._world.structureTiles;

			for (let i = 0, length = tiles.length; i < length; ++i) {
				const tile = tiles[i];
				const structure = tile.data.structure;
				let type;
				let dead;
				let injured;
				let survive;
				let cost;

				if (structure && structure.population && tile.quake.health > 0 && Math.random() > 0.75) { // 25% chance to kill some extras
					type = AlertPopup.TYPE_DEAD;
					dead = structure.population * 0.2;
					cost = structure.cost * 0.15;
					dead = Math.random() > 0.5 ? Math.ceil(dead) : Math.floor(dead);
					injured = Math.max(0, structure.population - dead);
					survive = 0;
					this._totalDestroyed++;

					this._hospitalDestroyed = structure.special && structure.special === 'hospital';
					this._schoolDestroyed = structure.special && structure.special === 'school';

					tile.alert.start(type);

					this._totalDeaths += dead;
					this._totalInjury += injured;
					this._totalSurvive += survive;
					this._totalCost += cost;
				}
			}
			const unhoused = common.scenario.population.unhoused;

			this._totalDeaths += P3.math.randomInt(0, unhoused) * 0.5; // kills a random amount of unhoused civs
			this._totalDeaths *= Math.max(1 - (common.scenario._ccUpgrades.length / 10), 0.5);	// kills a percentage of people depending on how many upgrades they have bought
			this._totalDeaths = Math.floor(this._totalDeaths);
			this._totalSurvive = common.scenario.population.total - this._totalDeaths;

			if (!this._destroyed) {
				this.signals.disasterEnd.dispatch(this);
			}
			this._isRunning = false;
			this._canStart = false;
		});
	}

	pulse() {
		const tiles = this._world.structureTiles;

		for (let i = 0, length = tiles.length; i < length; ++i) {
			const tile = tiles[i];

			if (!tile.isWater) {
				let force = P3.math.randomInt(this.pulseForce.min, this.pulseForce.max);

				// burning buildings take bonus damage
				tile.quake.isFire && (force *= 1.2);
				tile.quake.health = Math.max(0, tile.quake.health - (force * tile.quake.magnitude));
				tile.quake.health <= 0 && this.damageStructure(tile);

				if (tile.quake.health / tile.strength < 0.74 && Math.random() < 0.02) {
					this.igniteStructure(tile);
				}
			}
		}
	}

	igniteStructure(tile) {
		if (tile.quake.isFire) {
			return;
		}
		if (tile.data.structure && tile.data.structure.population <= 0) {
			return;
		}
		tile.quake.isFire = true;

		tile.playFireAnim();
	}

	damageStructure(tile) {
		if (tile.damaged) {
			return;
		}
		tile.damaged = true;

		const structure = tile.data.structure;

		if (structure && structure.population > 0) {
			let type;
			let dead;
			let injured;
			let survive;
			let cost;
			const chance = Math.random();

			if ((structure.population > 12 && chance > 0.6) || tile.quake.isFire) {
				type = AlertPopup.TYPE_DEAD;
				dead = structure.population * 0.2;
				dead = Math.random() > 0.5 ? Math.ceil(dead) : Math.floor(dead);
				cost = structure.cost * 0.4;
				injured = Math.max(0, structure.population - dead);
				survive = 0;
			} else if (chance >= 0.3 && chance <= 0.6) {
				type = AlertPopup.TYPE_CRITICAL;
				dead = Math.ceil(structure.population * 0.05);
				cost = structure.cost * 0.2;
				injured = Math.max(0, structure.population - dead);
				survive = 0;
			} else {
				type = AlertPopup.TYPE_INJURED;
				dead = 0;
				cost = structure.cost * 0.25;
				injured = Math.floor(structure.population * 0.5);
				survive = Math.max(0, structure.population - injured);
			}
			this._totalDeaths += dead;
			this._totalInjury += injured;
			this._totalSurvive += survive;
			this._totalCost += cost;
			tile.parent && tile.alert.start(type);
		}
	}
}
